import { MchVerifyStatus } from './MchVerifyStatus';

/**
 * 实名认证状态
 *
 */
export enum UserVerifyStatus {
    Initial = MchVerifyStatus.NotRealName, // 未认证
    Auditing = MchVerifyStatus.Auditing, // 审核中
    AuditReject = MchVerifyStatus.BeModify, // 审核拒绝，待修改资料
    PaperSending = MchVerifyStatus.PaperSending, // 待邮寄合同
    PaperProcessing = MchVerifyStatus.PaperProcessing, // 合同审核中
    AuditAgree = MchVerifyStatus.Success, // 审核成功
}
